import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { mapTo } from 'rxjs/operators';
import { AclService } from 'src/app/acl/acl.service';
import { LogService } from 'src/app/shared/log/log.service';
import { LogType } from 'src/app/shared/log/log.service.types';

export const fetchAccountAclGuard = (accountUrlParam: string): CanActivateFn => routeSnapshot => {
  const aclService = inject(AclService);
  const logService = inject(LogService);
  const accountId = routeSnapshot.params[accountUrlParam];

  if (!accountId) {
    logService.logComponentError(
      new Error(`URL param "${accountUrlParam}" is empty`),
      LogType.ACCOUNT,
      fetchAccountAclGuard.name,
    );

    return true;
  }

  return aclService.fetchAclForAccount(accountId)
    .pipe(
      mapTo(true),
    );
};
